export default __webpack_public_path__ + "static/media/move.22ef4808.svg";